module.exports = __webpack_public_path__ + "static/media/defaultAvatar29.8dc59511.svg";